
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/schools",
      function () {
        return require("private-next-pages/admin/schools/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/schools"])
      });
    }
  